const appraisal = 'appraisal';
const vehicleConfiguration = 'vehicleconfiguration';

type Resource = {
  controller: string;
  resource: string;
  version: number;
};

const GetAcquisitionByAppraisal: Resource = {
  controller: appraisal,
  resource: '{limited}/acquisition/details',
  version: 3
};

const GetAppraisalSummaries: Resource = {
  controller: appraisal,
  resource: 'summaries',
  version: 3
};

const RecordAnalytics: Resource = {
  controller: 'Analytics',
  resource: '',
  version: 4
};

const GetInHouseStockImage: Resource = {
  controller: vehicleConfiguration,
  resource: 'imageforYMMT',
  version: 5
};

export type AxiosResponse<T> = {
  data: {
    content: T;
  };
};

export type GQLError = {
  message: string;
  locations: { line: number; column: number }[];
  path?: string[];
  extensions?: {
    code: string;
  };
};

export { GetAcquisitionByAppraisal, GetAppraisalSummaries, RecordAnalytics, GetInHouseStockImage };
